<template>
  <Modal title="Броеви" @close="close">
    <div v-if="!loading">
      <div class="tabs is-toggle is-fullwidth is-small">
        <ul>
          <li :class="{'is-active': tab === 'copy'}">
            <a @click="tab = 'copy'">
              <span class="icon is-small"><i class="fa fa-copy"/></span>
              <span>Земи броеви</span>
            </a>
          </li>
          <li :class="{'is-active': tab === 'sms'}">
            <a @click="tab = 'sms'">
              <span class="icon is-small"><i class="fa fa-comment"/></span>
              <span>Испрати SMS</span>
            </a>
          </li>
        </ul>
      </div>

      <div v-if="tab === 'copy'">
        <input type="number" class="input" step="5" :value="chunks" @input="chunks=parseInt($event.target.value)" min="20"
               :max="numbers.length"/>

        <label class="has-text-centered is-block mt-2" v-for="block in blocks" :key="block">
          <span v-if="blocks !== 1">Дел {{block}} - <a @click="onCopy(numbersText(block-1))">Копирај дел</a></span>
          <textarea rows="10" class="textarea" :value="numbersText(block-1)" readonly></textarea>
        </label>
      </div>

      <div v-else>
        <p class="mb-2">
          Порака до <strong>{{smsRecipients.length}}</strong> {{smsRecipients.length === 1 ? 'број' : 'броеви'}}
        </p>
        <textarea rows="6" class="textarea" v-model="smsBody" placeholder="Внесете текст на пораката..."></textarea>

        <div class="level is-mobile mt-3 mb-1" v-if="smsBody.length">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Карактери</p>
              <p class="title is-6">{{smsInfo.length}}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">SMS делови</p>
              <p class="title is-6">{{smsInfo.segments}}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Вкупно пораки</p>
              <p class="title is-6">{{smsInfo.total}}</p>
            </div>
          </div>
        </div>
        <p class="help" v-if="smsBody.length">
          {{smsInfo.encoding}} · уште {{smsInfo.remaining}} {{smsInfo.remaining === 1 ? 'карактер' : 'карактери'}} во овој дел
        </p>
        <p class="help is-danger" v-if="!smsRecipients.length">
          Нема валидни броеви за испраќање.
        </p>
      </div>
    </div>

    <Loading v-else variant="is-white"/>

    <template v-slot:footer>
      <button v-if="tab === 'copy'" v-on:click="onCopy(null)" class="button is-success">
        <span class="icon"><i class="fa fa-copy"/></span>
        <span>Копирај ги сите</span>
      </button>

      <template v-else>
        <button v-if="!confirming" @click="confirming = true" :disabled="!canSend" class="button is-info">
          <span class="icon"><i class="fa fa-paper-plane"/></span>
          <span>Испрати на {{smsRecipients.length}}</span>
        </button>
        <template v-else>
          <button @click="sendSms" :class="{'is-loading': sending}" class="button is-danger">
            <span class="icon"><i class="fa fa-paper-plane"/></span>
            <span>Потврди испраќање</span>
          </button>
          <button @click="confirming = false" :disabled="sending" class="button">Откажи</button>
        </template>
      </template>
    </template>
  </Modal>
</template>

<script>
import Loading from "../Loading";

export default {
  name: "ClientsNumbersModal",
  components: {Loading},
  props: {
    endpoint: String,
    query: Object,
  },
  data() {
    return {
      numbers: [],
      loading: true,
      chunks: 20,
      tab: "copy",
      smsBody: "",
      sending: false,
      confirming: false,
    };
  },
  computed: {
    numbersText() {
      return (page)=> this.numbers.slice(page*this.chunks, page*this.chunks+this.chunks).filter(a => a.startsWith("07")).join(", ")
    },
    allNumbers(){
      return this.numbers.filter(a => a.startsWith("07")).join(", ");
    },
    blocks(){
      return Math.ceil(this.numbers.length/(this.chunks|| 20))
    },
    smsRecipients() {
      return [...new Set(this.numbers.filter(a => a && a.startsWith("07")))];
    },
    smsInfo() {
      const text = this.smsBody;
      const len = text.length;
      // Cyrillic / any non-ASCII forces UCS-2 encoding: 70 chars single, 67 concatenated.
      const unicode = text.split("").some(c => c.charCodeAt(0) > 127);
      const single = unicode ? 70 : 160;
      const multi = unicode ? 67 : 153;
      const segments = len === 0 ? 0 : (len <= single ? 1 : Math.ceil(len / multi));
      const capacity = segments <= 1 ? single : segments * multi;
      return {
        encoding: unicode ? "Кирилица (Уникод)" : "GSM-7",
        length: len,
        segments,
        remaining: segments === 0 ? single : capacity - len,
        total: segments * this.smsRecipients.length,
      };
    },
    canSend() {
      return !this.sending && this.smsBody.trim().length > 0 && this.smsRecipients.length > 0;
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },
    onCopy(toCopy) {
      this.$copyText(toCopy || this.allNumbers).then(() => {
        this.$toast({type:"is-success", message:"Успешно копирано"});
        if(!toCopy)this.close();
      })
    },
    sendSms() {
      const body = this.smsBody.trim();
      if (!body || !this.smsRecipients.length) return;
      this.sending = true;
      this.$http.post("/campaigns/enqueue", {body, recipients: this.smsRecipients})
          .then(res => {
            this.sending = false;
            this.confirming = false;
            if (!res) return; // cancelled request
            const {queued, skipped} = res.data;
            this.$toast({
              type: "is-success",
              message: `Испратени ${queued} пораки${skipped ? `, прескокнати ${skipped}` : ""}`
            });
            this.close();
          })
          .catch(() => {
            this.sending = false;
            this.confirming = false;
          });
    }
  },
  watch: {
    smsBody() {
      // Editing the text after asking to confirm requires re-confirming.
      this.confirming = false;
    },
    tab() {
      this.confirming = false;
    }
  },
  mounted() {
    const url = this.$urify(Object.assign({}, this.query, {phones: true}), ["page"]);
    this.$http.get("/" + this.endpoint + url)
        .then(a => {
          this.numbers = a.data.data;
          this.loading = false
          this.chunks = this.numbers.length;

        });
  }
}
</script>
